<template>
  <div>
    <v-dialog v-model="dialogproject" width="600">
      <v-card>
        <v-card-title>
        <h3 class="titleText--text">Create new group</h3>
        <v-spacer/>
        <v-btn icon @click="dialogproject = false">
          <v-icon color="titleText">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-text-field
                  v-model="groupname"
                  placeholder="Group name"
                  style="border-radius: 8px;"
                  background-color="#f3f5f8"
                  solo
                  flat
                  hide-details="auto"
                  height="36"
                ></v-text-field>
                <v-select
                  multiple
                  v-model="varlistitemselected"
                  :items="varlistitem"
                  hide-details="auto"
                  placeholder="Select variables"
                  background-color="#f3f5f8"
                  solo
                  style="border-radius: 8px;"
                  flat
                  class="mt-3"
                >
                <template v-slot:selection="{item}">
                  <v-chip small dark color="blue" class="font-weight-bold">{{item}}</v-chip>
                </template>
                </v-select>
                <v-btn :disabled="!(groupname && varlistitemselected)" depressed class="mt-3" color="blue" @click="OngroupSaveClick()">
                  <span class="font-weight-bold text-capitalize" :class="!(groupname && varlistitemselected) ? 'titleText--text' : 'white--text'" >Create group</span>
                </v-btn>
      </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import apifactory from "../../api";

export default {
  data: () => ({
    itemlistfinal: [],
    dialogproject: false,
    parmVariablename: "Variable and Group ",
    groupname: "",
    varlistitem: [],
    varlistitemselected: [],
  }),
  methods: {
    OnloadCall(varlistofgroup) {
      this.varlistitem = varlistofgroup.roi_grouplist;
     // alert("call OnloadCall" + JSON.stringify(this.varlistitem));
      this.dialogproject = true;
      this.get_saved_vargrp_for_model();
    },

    get_saved_vargrp_for_model() {
      apifactory
        .api_get_save_roi_parameters()
        .then((res) => {
          // alert(res.id);
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            let templist = [];
            templist = res.data.roi_group;

            this.itemlistfinal = templist;
            for (let element in this.itemlistfinal) {
              alert(JSON.stringify(this.itemlistfinal[element]));
            }
            //alert(JSON.stringify(this.itemlistfinal));
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    OngroupSaveClick() {
      this.savegroup();
      this.dialogproject = false
    },
    resetctrl(){
let newlist = [];
        let newlistselected = [];
        newlist = this.varlistitem;
        newlistselected=this.varlistitemselected;
        for (let element in newlist) {
          for (let i in newlistselected) {
            if (newlist[element] == newlistselected[i]) {
               // alert(newlist[element]);// var spliced = newlist.splice(i, 1);
                newlist.splice(newlistselected[i],1);
            }
          }
         
        }
        this.groupname='';

    },

    savegroup() {
      apifactory
        .api_get_save_roi_parameters_group(
          this.varlistitemselected,
          this.groupname
        )
        .then((res) => {
          if (res.status != 200) {
            alert(res.message);
          } else {
            alert("done");
            this.resetctrl();
            this.$parent.openmanagegroupctrl();
            this.get_saved_vargrp_for_model();
            
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.headerbox {
  font-weight: bold;
  font-style: italic;
  font-size: 25px;
  color: black;
}

.headerboxtitle {
  font-size: 20px;
}

.card2 {
  background-color: #ffff00;
}
</style>
